// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tUlD","question":"styles_question__ggHWP","description":"styles_description__NC9ne"};